var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReviewStarHalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 15 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  fillRule: "evenodd",
  d: "M7 0c-.133.005-.247.087-.28.2L5.197 4.694H.324a.33.33 0 0 0-.311.218c-.035.134 0 .268.12.335l3.942 2.782-1.504 4.493c-.035.134 0 .268.121.352.052.033.12.05.19.05s.138-.017.19-.067L7 10.082zm7 5.095a.24.24 0 0 0 0-.173z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  fillRule: "evenodd",
  d: "M7.016 0c.133.005.247.087.281.2l1.521 4.493h4.874c.138 0 .26.084.311.218.035.134 0 .268-.12.335L9.94 8.028l1.504 4.493c.035.134 0 .268-.12.352a.36.36 0 0 1-.191.05.27.27 0 0 1-.19-.067l-3.928-2.774V0zm-7 5.095a.24.24 0 0 1 0-.173z",
  clipRule: "evenodd"
})));
export default SvgReviewStarHalf;